import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const SafetyTipsPage = () => {
  const tips = [
    {
      icon: '🤝',
      title: 'Meet in Public Places',
      desc: 'When meeting a buyer or seller in person, choose a public location like a shopping center, bank, or police station.'
    },
    {
      icon: '👀',
      title: 'Inspect Before Paying',
      desc: 'Always inspect products in person before making payment. Verify that the item matches the listing description and photos.'
    },
    {
      icon: '💬',
      title: 'Use In-App Messaging',
      desc: 'Keep your communication on TopInfo\'s messaging system. This creates a record and helps us resolve any disputes.'
    },
    {
      icon: '🔒',
      title: 'Protect Personal Information',
      desc: 'Never share your password, bank PINs, or sensitive financial details with other users. TopInfo staff will never ask for your password.'
    },
    {
      icon: '⚠️',
      title: 'Watch for Red Flags',
      desc: 'Be cautious of deals that seem too good to be true, sellers who pressure you to pay quickly, or requests for unusual payment methods.'
    },
    {
      icon: '📱',
      title: 'Verify Phone Numbers',
      desc: 'Call the provided phone number to verify the seller\'s identity before committing to a purchase. Check that the number matches their listing.'
    },
    {
      icon: '⭐',
      title: 'Check Reviews & Ratings',
      desc: 'Look at the seller\'s reviews and ratings from previous buyers. Established sellers with good ratings are generally more trustworthy.'
    },
    {
      icon: '🚩',
      title: 'Report Suspicious Activity',
      desc: 'If you encounter a suspicious listing or user, use the report button on the listing page or contact us at info@topinfo.rw.'
    },
  ];

  return (
    <>
      <SEO title="Safety Tips" description="Stay safe while buying, selling, and booking services on TopInfo Rwanda. Tips for secure transactions and meeting safely." keywords="safety tips TopInfo Rwanda, safe buying selling Rwanda, secure transactions marketplace, online safety Kigali" />
      <div className="min-h-screen bg-gray-50/50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Safety Tips</h1>
          <p className="text-gray-500 mb-8">Stay safe while buying and selling on TopInfo Rwanda.</p>

          <div className="grid gap-4">
            {tips.map((tip, i) => (
              <div key={i} className="bg-white rounded-2xl border border-gray-100 p-5 flex gap-4 items-start">
                <span className="text-2xl flex-shrink-0 mt-0.5">{tip.icon}</span>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">{tip.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{tip.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 bg-accent-50 rounded-2xl border border-accent-200 p-6 text-center">
            <h2 className="text-lg font-semibold text-gray-900 mb-2">Report a Problem</h2>
            <p className="text-gray-600 text-sm mb-4">If you've been scammed or encountered fraudulent activity, contact us immediately.</p>
            <a href="mailto:info@topinfo.rw" className="inline-flex items-center gap-2 bg-primary-600 text-white px-6 py-2.5 rounded-xl font-medium hover:bg-primary-700 transition">
              Report to info@topinfo.rw
            </a>
          </div>

          <div className="mt-8 text-center">
            <Link to="/" className="text-primary-600 hover:text-primary-700 text-sm font-medium">&larr; Back to Home</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default SafetyTipsPage;
